/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import './AmountDescriptorControl.scss';

import MedliSearchTerm from '../../../components/MedliSearchTerm';
import MedliTerm from '../../../components/MedliTerm';
import composeDescription from '../../../../models/HealthEntryCompose/description';
import { Card, CardRowUI } from '../../../../bphComponents/bundle';

import { useMedliConstantsDescriptor } from '../../../hooks/useMedli';
import { useActiveUser } from '../../../hooks/useUser';

interface Props {
  description: any;
  goDescriptorList(): void;
  onSelectDescriptor(d): void;
}

const getChoices = (baseChoices, selectedChoice) => {
  const choices = [...baseChoices];

  if (!selectedChoice || !selectedChoice.id) {
    return choices;
  }
  const selectedId = selectedChoice.id;
  const selectedIndex = choices.findIndex(f => f.id === selectedId);

  if (selectedIndex > -1) {
    const selectedChoice = choices.splice(selectedIndex, 1)[0];
    choices.unshift(selectedChoice);
  } else {
    choices.unshift(selectedChoice);
  }

  return choices;
};

const AmountDescriptorControl: React.FC<Props> = (props) => {
  const { description } = props;

  const [{ descriptorList }] = useMedliConstantsDescriptor();
  const [{ preferredLanguageCode }] = useActiveUser();

  const descriptorData = composeDescription({ description }, preferredLanguageCode);
  const choices = getChoices(descriptorList, descriptorData.convertToSearchTerm());
  const selectedId = description ? description.id : null;
  const [isExpanded, setIsExpanded] = React.useState(!descriptorData.hasDescription());

  return (
    <Card.CardShape>
      <Card.CollapsibleSummaryWithControl
        label={(
          <div className="font-caption-1 font-color-gsMedDark">
            <FormattedMessage id="heValue.description.field.label" />
          </div>
        )}
        disableCollapseUntilValue={true}
        hasBottomBorder={true}
        value={descriptorData.hasDescription() ? <MedliTerm className="font-color-profile-accent" medliTerm={description} /> : null}
        isExpanded={isExpanded}
        isMultiLine={false}
        onClick={() => { setIsExpanded(!isExpanded); }}
      >
        {
          choices.map((d, index) => (
            <CardRowUI.SelectableRow
              key={index}
              onClick={() => {
                if (d.id === selectedId) {
                  return;
                }
                props.onSelectDescriptor(d);
                setIsExpanded(false);
              }}
              selectedClassName="fill-color-profile"
              isSelected={d.id === selectedId}
              hasBottomBorder={true}
            >
              <MedliSearchTerm term={d} />
            </CardRowUI.SelectableRow>
          ))
        }
        <CardRowUI.TextAction hasBottomBorder={true} forceBottomBorder={true} onClick={props.goDescriptorList}>
          <div className="font-body font-color-profile-accent" >
            <FormattedMessage id="heValue.description.search.label" />
          </div>
        </CardRowUI.TextAction>
      </Card.CollapsibleSummaryWithControl>
    </Card.CardShape>
  );
};

export default AmountDescriptorControl;
